/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_Faq_Q3Inputs */

const en_guide_json_syntax_errors_faq_q3 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does my JSON work in JavaScript but fail in a strict parser?`)
};

const ko_guide_json_syntax_errors_faq_q3 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JavaScript에서는 되는 JSON이 왜 엄격한 파서에서는 실패하나요?`)
};

const ja_guide_json_syntax_errors_faq_q3 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JavaScript では動く JSON が、なぜ厳格なパーサーでは失敗するのですか?`)
};

/**
* | output |
* | --- |
* | "Why does my JSON work in JavaScript but fail in a strict parser?" |
*
* @param {Guide_Json_Syntax_Errors_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_faq_q3 = /** @type {((inputs?: Guide_Json_Syntax_Errors_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_faq_q3(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_faq_q3(inputs)
	return ja_guide_json_syntax_errors_faq_q3(inputs)
});